import React,{useState} from "react";
import CompanyInformation from './CompanyInformation';
import DirectParent from './DirectParent';
import UltimateParent from './UltimateParent';
import Payment from './Payment';
import FormStatus from './FormStatus';



function ApplyNew(){
    const [page, setPage] = useState(0);
    const FormTitle = ['Company Information','Direct Parent','UltimateParent'/*,'FundRelations'*/,'Payment','Status']
    const PageDisplay = () =>{
        if (page === 0){
            return <CompanyInformation />;
        }else if (page === 1){
            return <DirectParent />;
        }else if (page === 2){
            return <UltimateParent />;
        }
        // else if (page === 3){
        //     return <FundRelations />;
        // }
        else if (page === 3){
            return <Payment />
        }
        else if (page === 4){
            return <FormStatus />
        }
    }

    return(
        <div className="StepForm">
            {/* <div className="progress-bar">
                <div className="fill-progressbar" style={{width : page === 0 ? "16.66%" : page == 1 ? "33.32" : page == 2 ? "49.98" : page == 3 ? "66.64" : page == 4 ? "83.3" : "100%"}}></div>
            </div> */}
            <div className="formlist">
                <h2 className='heading2'>Required Document <span>(Private Limited Companies)</span></h2>
                <ul>
                    <li>Letter of Authority  </li>
                    <li>Audited Annual Financial Statement / Report (latest available)</li>
                    <li>Consolidated Audited Annual Financial Statement / Report of the direct parent (If Any)</li>
                    <li>Consolidated Audited Annual Financial Statement / Report of the ultimate parent (If Any)</li>
                    <li>Statutory Auditor’s Certificate (if required)</li>
                    <li>Shareholding pattern on company’s letterhead </li>

                </ul>
            </div>
            <div className="form-container">
                <div className="form-body">
                    <h2 className="heading2">{FormTitle[page]}</h2>
                    {PageDisplay()}
                </div>
                <div className="form-footer">
                    <button disabled={page === 0} onClick={() => {setPage((currPage) => currPage - 1);}}>Prev</button>
                    <button disabled={page === FormTitle.length - 1} onClick={() => {setPage((currPage) => currPage + 1);}}>Confirm & Continue</button>
                </div>
            </div>
        </div>
    );    
}
export default ApplyNew